var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkvalidation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.222 10.065 L 22.888 10.065 C 23.109 10.065 23.321 10.146 23.478 10.29 C 23.634 10.434 23.722 10.629 23.722 10.832 L 23.722 25.515 C 23.722 25.583 23.702 25.651 23.664 25.71 C 23.626 25.769 23.572 25.817 23.507 25.851 C 23.442 25.884 23.368 25.9 23.293 25.898 C 23.219 25.897 23.146 25.876 23.083 25.84 L 17.055 22.36 L 11.027 25.839 C 10.964 25.875 10.891 25.896 10.817 25.898 C 10.742 25.9 10.669 25.883 10.604 25.85 C 10.538 25.817 10.484 25.768 10.446 25.709 C 10.408 25.65 10.388 25.583 10.388 25.515 L 10.388 10.832 C 10.388 10.629 10.476 10.434 10.632 10.29 C 10.789 10.146 11.001 10.065 11.222 10.065 Z M 22.055 11.599 L 12.055 11.599 L 12.055 23.435 L 17.055 20.551 L 22.055 23.435 L 22.055 11.599 Z",
    fill: "#797AF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkvalidation);
export default __webpack_public_path__ + "static/media/bookmarkvalidation.45840c1a194df526d5291d19349c4103.svg";
export { ForwardRef as ReactComponent };